import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PillarCard } from '../components/PillarCard';
import { Button } from '../components/ui/Button';
import { BookOpen, Users, PenTool, Heart } from 'lucide-react';
export function Home() {
  return <div className="min-h-screen bg-brand-cream" data-id="element-2003">
      <HeroSection title="Fat Liberation Learning & Community" subtitle="ReGrowth is a digital space for political education, community building, and radical imagination rooted in fat justice." bgColor="navy" textColor="white" tag="Welcome to ReGrowth" data-id="element-2004" />

      {/* Pillars Grid */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto -mt-20 relative z-20" data-id="element-2005">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2006">
          <PillarCard title="Fat Liberation & Justice" description="The ethical anchor and political framework of our work. Understand the systems of power, our lineage, and our commitments." path="/fat-liberation" color="magenta" icon={<Heart className="h-10 w-10 text-brand-magenta mb-4" data-id="element-2008" />} data-id="element-2007" />

          <PillarCard title="Learning & Growth" description="Courses, cohorts, and resources to deepen your political analysis and unlearn anti-fat bias. We don't just publish ideas—we support growth." path="/learning-growth" color="cyan" icon={<BookOpen className="h-10 w-10 text-brand-cyan mb-4" data-id="element-2010" />} data-id="element-2009" />

          <PillarCard title="The Digital Publication" description="A journal-like platform for essays, reporting, and art from fat creators. Intellectually rich, confident, and unapologetic." path="/publication" color="orange" icon={<PenTool className="h-10 w-10 text-brand-orange mb-4" data-id="element-2012" />} data-id="element-2011" />

          <PillarCard title="About ReGrowth" description="Who we are, how we work, and the principles that guide us. Transparency, accountability, and human grounding." path="/about" color="lime" icon={<Users className="h-10 w-10 text-brand-lime mb-4" data-id="element-2014" />} data-id="element-2013" />
        </div>
      </section>

      {/* Mission Statement */}
      <section className="py-24 bg-white" data-id="element-2015">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-2016">
          <h2 className="text-3xl md:text-5xl font-black uppercase mb-8 text-brand-black leading-tight" data-id="element-2017">
            We believe in a world where fat people are{' '}
            <span className="text-brand-magenta" data-id="element-2018">free</span>,{' '}
            <span className="text-brand-cyan" data-id="element-2019">respected</span>, and{' '}
            <span className="text-brand-orange" data-id="element-2020">powerful</span>.
          </h2>
          <p className="text-xl text-gray-600 mb-12 leading-relaxed max-w-2xl mx-auto" data-id="element-2021">
            ReGrowth exists to bridge the gap between academic theory and lived
            experience, creating accessible pathways to radicalization and
            community.
          </p>
          <Button color="navy" size="lg" withArrow data-id="element-2022">
            Join Our Community
          </Button>
        </div>
      </section>
    </div>;
}